module.exports = __webpack_public_path__ + "static/img/C4D0012.cf18019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0012.jpg
// module id = gtap
// module chunks = 0